import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "date",
})
export class DatePipe implements PipeTransform {
  transform(date: Date): string {
    return this.formatDate(date);
  }

  private formatDate(date: Date) {
    if (typeof date === "string") date = new Date(date);

    const { day, month, year } = this.getDateParts(date);

    const formattedDay = this.formatDayOrMonth(day);
    const formattedMonth = this.formatDayOrMonth(month);

    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  private getDateParts(date: Date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return { day, month, year };
  }

  private formatDayOrMonth(dayOrMonth: number) {
    let formattedDayOrMonth = dayOrMonth.toString();
    if (dayOrMonth < 10) formattedDayOrMonth = "0" + formattedDayOrMonth;
    return formattedDayOrMonth;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/pipes/date.pipe.ts